// extracted by mini-css-extract-plugin
module.exports = {"root":"skeleton_root__eyZui","shimmer":"skeleton_shimmer__POw91","light":"skeleton_light__ICV6s skeleton_root__eyZui","inverted":"skeleton_inverted__uAD1T skeleton_root__eyZui"};